import { Callout, HTMLTable, Spinner } from "@blueprintjs/core";
import { useEffect, useState } from "react";
import { Trans } from "react-i18next";

import i18n from "../../../../i18n";
import { authenticatedGetFetch } from "../../../../utils/AuthenticatedFetch";
import PieChart from "../../../Charts/PieChart";

export default function VehicleClasses(props) {
  const [countries, setCountries] = useState();

  useEffect(() => {
    authenticatedGetFetch(
      "/ow/dc/perf/vehicleclasses?" +
        new URLSearchParams({
          srv: props.srv,
          ...(props.from && { from: props.from }),
          ...(props.to && { to: props.to }),
        }),
      (countries) => setCountries(countries)
    );
  }, [props.srv, props.from, props.to]);

  return (
    <Callout icon="mobile-video" title={<Trans>vehicle classes</Trans>}>
      {countries ? (
        <div className="flexbox-left">
          <div>
            <HTMLTable compact={true} striped={true}>
              <thead>
                <tr>
                  <th>
                    <Trans>vehicle classes</Trans>
                  </th>
                  <th>
                    <Trans>number of transaction</Trans>
                  </th>
                </tr>
              </thead>
              <tbody>
                {countries.map((l) => (
                  <tr key={l.label}>
                    <td>
                      <Trans>{l.label || "unknown"}</Trans>
                    </td>
                    <td>{l.count}</td>
                  </tr>
                ))}
              </tbody>
            </HTMLTable>
          </div>
          <div>
            <PieChart
              labels={countries.map((c) => i18n.t(c.label))}
              data={countries.map((c) => c.count)}
              title={i18n.t("vehicle classes")}
            />
          </div>
        </div>
      ) : (
        <Spinner />
      )}
    </Callout>
  );
}
